import { useState } from 'react';
import {
  Briefcase,
  Compass,
  Newspaper,
  TrendingUp,
  Sparkles,
  type LucideIcon,
} from 'lucide-react';
import type { Initiative } from '../shared/types.ts';

const ICONS: Record<string, LucideIcon> = {
  Briefcase,
  Compass,
  Newspaper,
  TrendingUp,
};

export function InitiativeCard({ initiative }: { initiative: Initiative }) {
  const Icon = ICONS[initiative.iconName] ?? Sparkles;
  const [imgFailed, setImgFailed] = useState(false);
  const showImage = !!initiative.imageUrl && !imgFailed;
  return (
    <div className="rounded-2xl border border-amber-200/60 shadow-sm overflow-hidden bg-gradient-to-b from-amber-50/70 via-card to-card">
      {showImage ? (
        <div className="w-full aspect-video bg-muted overflow-hidden">
          <img
            src={initiative.imageUrl!}
            alt=""
            className="w-full h-full object-cover"
            loading="lazy"
            onError={() => setImgFailed(true)}
          />
        </div>
      ) : (
        <div className="w-full aspect-video bg-gradient-to-br from-amber-100 to-rose-100 flex items-center justify-center">
          <Icon size={56} className="text-amber-700/60" strokeWidth={1.25} />
        </div>
      )}

      <div className="p-6 space-y-4">
        <div>
          <span className="text-[11px] uppercase tracking-wider font-semibold text-amber-700 bg-amber-100/80 rounded-full px-2 py-0.5 inline-block">
            {initiative.category}
          </span>
          <p className="mt-2 font-bold text-xl leading-tight">{initiative.title}</p>
          <p className="mt-1 text-[13px] text-muted-foreground italic">{initiative.tagline}</p>
        </div>

        <p className="text-[15px] text-foreground/80 leading-relaxed">
          {initiative.description}
        </p>

        {initiative.howItWorks.length > 0 && (
          <div className="space-y-3">
            <p className="text-[11px] uppercase tracking-wider font-semibold text-foreground/60">
              How it works
            </p>
            <ol className="space-y-2.5">
              {initiative.howItWorks.map((step, idx) => (
                <li key={idx} className="flex gap-3 text-[14px] leading-relaxed text-foreground/85">
                  <span className="shrink-0 w-5 h-5 rounded-full bg-amber-100 text-amber-800 text-[11px] font-semibold flex items-center justify-center mt-0.5">
                    {idx + 1}
                  </span>
                  <span>{step}</span>
                </li>
              ))}
            </ol>
          </div>
        )}

      </div>
    </div>
  );
}
